import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	customiseSidebar: {
		id: 'navigation-apps-sidebar-nav4-sidebar-content.configurable-menu.customise-sidebar.trigger.customise-sidebar',
		defaultMessage: 'Customize sidebar',
		description: 'Message for customise sidebar nav menu item in the sidebar',
	},
});
